export interface ScriptureReference {
	bookName: string;
	chapterStart: number;
	chapterEnd: number | null;
	verseStart: number | null;
	verseEnd: number | null;
}

export const ScriptureReferenceParser = {
	parse: (text: string) => {
		let verseRegex = "\\d{1,3}(?::\\d{1,3})?(?:\\s?(?:[-&]\\s?(?:\\d{1,3}:)?\\d+))*";

		const scriptureRegex =
			"(?:Genesis|1 Kings|2 Kings|1 Timothy|2 Timothy|1 Peter|2 Peter|1 Samuel|2 Samuel|1 John|2 John|3 John|1 Chronicles|2 Chronicles|1 Corinthians|2 Corinthians|1 Thessalonians|2 Thessalonians|I Kings|II Kings|I Timothy|II Timothy|I Peter|II Peter|I Samuel|II Samuel|I John|II John|III John|I Chronicles|II Chronicles|I Corinthians|II Corinthians|I Thessalonians|Thessalonians|Exodus|Leviticus|Numbers|Deuteronomy|Joshua|Judges|Ruth|Ezra|Nehemiah|Esther|Job|Psalms?|Proverbs?|Ecclesiastes|Songs? of Solomon|Song of Songs|Isaiah|Jeremiah|Lamentations|Ezekiel|Daniel|Hosea|Joel|Amos|Obadiah|Jonah|Micah|Nahum|Habakkuk|Zephaniah|Haggai|Zechariah|Malachi|Matt|Matthew|Mark|Luke|John|Acts?|Acts of the Apostles|Romans|Galatians|Ephesians|Phil+ippians|Colossians|Titus|Philemon|Hebrews|James|Jude|Revelations?)\\s" +
			verseRegex;

		const matchedScriptureReferences = text.match(new RegExp(scriptureRegex, "gi"));

		return matchedScriptureReferences ? matchedScriptureReferences : [];
	},
};
